// extracted by mini-css-extract-plugin
module.exports = {"info":"ArtistIndexBannerInfo-info-1y_z0"};